import { render, staticRenderFns } from "./ClientCollectionsDetailsIframe.vue?vue&type=template&id=816fc904"
import script from "./ClientCollectionsDetailsIframe.vue?vue&type=script&lang=js"
export * from "./ClientCollectionsDetailsIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports